import SearchIcon from '@/icons/bwi/search.svg'
import { useTranslations } from '@/utils/locale'
import { cx } from '@/utils/strings'

export default function HelpSearch({ searchSize }: { searchSize?: string }): JSX.Element {
  const { t } = useTranslations()
  const searchField = (
    <div className={cx('relative', searchSize !== 'large' && 'max-w-[300px]')}>
      <input
        name="search"
        type="text"
        placeholder={t('What are you looking for?')}
        readOnly
        className={cx(
          'bg-white rounded-full mx-auto w-full placeholder:text-sm placeholder:text-indigoBlue px-4 py-2 dark:placeholder:text-secondary-200 dark:bg-secondary-700 dark:border-secondary-400 dark:border',
          searchSize === 'large' && 'placeholder:text-lg py-4 '
        )}
        onKeyDown={(e) => {
          if (e.code === 'Enter' || e.code === 'Space') {
            window.location.assign('/search/?type=help')
          }
        }}
        onClick={() => {
          window.location.assign('/search/?type=help')
        }}
      />
      <SearchIcon className="absolute text-indigoBlue dark:text-secondary-50 top-0 bottom-0 right-4 m-auto w-4 h-4 lg:w-5 lg:h-5 pointer-events-none" />
    </div>
  )

  return searchField
}
